import { INCREMENT_INTERACTIONS, RESET_TAGGING } from './types';

export const incrementInteractions = payload => ({
  type: INCREMENT_INTERACTIONS,
  payload,
});

export const resetTagging = () => ({
  type: RESET_TAGGING,
});
